module.exports = __webpack_public_path__ + "static/media/fps.fad99a51.png";